import React from 'react'
import { ApolloClient } from 'apollo-client'
import { setContext } from 'apollo-link-context'
import { createHttpLink } from 'apollo-link-http'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { ApolloProvider } from 'react-apollo'
import { App } from './'
import * as Sentry from '@sentry/browser'

Sentry.init({ dsn: process.env.REACT_APP_SENTRY_DSN })

let httpLink = createHttpLink({ uri: process.env.REACT_APP_GRAPHQL_ROOT })

let middlewareLink = setContext(() => ({
  headers: {
    // get the authentication token from local storage if it exists
    authorization: "Token " + localStorage.getItem('token') || null,
  }
}))

const client = new ApolloClient({
  link: middlewareLink.concat(httpLink),
  cache: new InMemoryCache()
})


const Root = () => {
  return (
    <ApolloProvider client={client}>
      <App />
    </ApolloProvider>
  )
}


export default Root



// WEBPACK FOOTER //
// ./src/containers/Root.prod.js